<template>
  <div class="navigation">
    <main :style="navGridStyle">
      <template v-for="(item,index) in data">
        <!-- 英文版：在指定项前强制换行，避免第一行过挤 -->
        <div v-if="item.enRowBreak" :key="'en-break-' + index" class="nav-en-break" aria-hidden="true"></div>
        <div class="nav-item" :key="item.labelKey || index">
          <a-dropdown
            v-if="item.children && item.children.length"
            :getPopupContainer="getPopupContainer"
            placement="bottomCenter"
            :destroyPopupOnHide="true"
          >
            <div :class="`title ${getActive(item) && 'active'}`" @click="submit(item)">
              <span>{{ item.label }}</span>
              <i class="iconfont icon-wjjf_icon_line_arrow_down" />
            </div>
            <AntMenu
              className="antd_menu_navigation"
              :data="item.children"
              :defaultSelectedKeys="[$route.path]"
              slot="overlay"
              placement="bottom"
              class="antd_menu"
              align="center"
              :submit="submit"
            />
          </a-dropdown>
          <div
            v-else
            :class="`title ${getActive(item) && 'active'}`"
            @click="submit(item)"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </template>
    </main>
    <a-modal :centered="true" :title="t('nav.tipTitle')" :visible="reveal" @cancel="() => setReveal()" :footer="null" width="70rem">
      <div class="antd_modal">
        <img :src="require('@/assets/images/public/call_example.png')" alt="" srcset="">
        <div class="antd-model-tips">{{ t('nav.vipTips') }}</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { t } from '@/locales';

export default {
  data() {
    return {
      data: [],
      standardSearch: {},
      reveal: false,
      standardSearchList: {}, // 标准检索
      platformAssistantList: {}, // 平台助手
    }
  },
  computed: {
    navGridStyle() {
      const n = this.data.length || 1;
      const isEn = this.$store.state.language === 'english';
      // 中文：单行 grid，列随文案
      // 英文：不用 grid 两行（列宽会跨行对齐，HOME 会被下面长项撑宽），改由 CSS flex 按内容宽换行
      if (isEn) return {};
      return { gridTemplateColumns: `repeat(${n}, auto)` };
    }
  },
  created() {
    this.setStandard();
    this.setPlatformAssistant();
    this.setData();
  },
  watch: {
    '$store.state.language'() {
      // 切换 zh/en 语言包后重建导航文案（字段 key 不变）
      this.setStandard();
      this.setPlatformAssistant();
      this.setData();
    }
  },
  methods: {
    t,
    getPopupContainer() {
      return document.body;
    },
    getActive({ labelKey = null, key = null, value = null }) {
      let { path = null, query = null } = this.$route;
      if (value) {
        switch (labelKey) {
          case 'nav.standardSearch': return path === value;
          case 'nav.benchmarking': return query.url === value;
          case 'nav.platformAssistant': return path === value;
        }
      } else {
        return path === key;
      }
    },
    setReveal(value = false) {
      this.reveal = value;
    },
    submit({ mode, key }) {
      let fn = () => key && this.$router.$push(key);
      if (mode) {
        if (key == "/standardList/item") {
          this.$FN.limitsTips({ list: mode, key: "some", tips: false }).then(res => res ? fn() : this.setReveal(!res));
        } else {
          this.$FN.limitsTips({ list: mode, key: "some" }).then(res => res && fn());
        }
      } else {
        fn();
      };
    },
    setStandard() {
      let standardSearchList = {};
      let list = [
        { labelKey: 'nav.standardSearch', label: t('nav.standardSearch'), key: "/standard?mode=standardSearch_system_search", mode: ["standardSearch_system_search"], rolesKey: "standardSearch" },
        { labelKey: 'nav.csepdi', label: t('nav.csepdi'), key: "/standard?mode=standardSearch_zny_allStartStopBtn", mode: ["standardSearch_zny_allStartStopBtn"], rolesKey: "standardSearch_zny_allStartStopBtn" },
        { labelKey: 'nav.snerdi', label: t('nav.snerdi'), key: "/standard?mode=standardSearch_state_nuclear_search_list_details", mode: ["standardSearch_state_nuclear_search_list_details"], rolesKey: "standardSearch_state_nuclear_search_list_details" },
        { labelKey: 'nav.gxedi', label: t('nav.gxedi'), key: "/standard?mode=standardSearch_intermediate_energy_search_list_details", mode: ["standardSearch_intermediate_energy_search_list_details"], rolesKey: "standardSearch_intermediate_energy_search_list_details" },
      ];

      let mode = ["standardSearch_system", "standardSearch_zny_allStartStopBtn", "standardSearch_state_nuclear_search_list_details", "standardSearch_intermediate_energy_search_list_details"];

      let returnedValue = this.$FN.filterLimitsVisible({ data: list });
      if (returnedValue.length === 1) {
        standardSearchList = { labelKey: 'nav.standardSearch', label: t('nav.standardSearch'), key: "/standard?mode=standardSearch_system_search", rolesKey: "standardSearch", value: "/standard", mode };
      } else {
        let obj = { labelKey: 'nav.standardSearch', label: t('nav.standardSearch'), rolesKey: "standardSearch", mode, key: "/standard?mode=standardSearch_system_search", value: "/standard", children: this.$FN.filterLimitsVisible({ data: list }) };
        standardSearchList = obj;
      };
      this.standardSearchList = standardSearchList;
    },
    // 设置平台助手
    setPlatformAssistant() {
      // 1（2018、2019、2020） && 2（2021、2022、2023、2024） 属于标准有效版本
      // 3（2018、2019、2020） && 4（2021、2022、2023、2024） 属于国际工程清单
      // rolesKey非常重要，与权限有关，用来判断是否存在这个
      // mode用来判断用户有没有权限点进去，没有权限就提示
      this.platformAssistantList = {
        labelKey: 'nav.platformAssistant',
        label: t('nav.platformAssistant'),
        value: "/platformAssistant",
        mode: ["surveyDesign_teamworks_tandard_2018"],
        rolesKey: "surveyDesign",
        children: [
          {
            labelKey: 'nav.teamwork',
            label: t('nav.teamwork'),
            children: [
              { labelKey: 'nav.stdValid2018', label: t('nav.stdValid2018'), key: '/platformAssistant?type=1&key=2018', mode: ["surveyDesign_teamworks_tandard_2018"] },
              { labelKey: 'nav.stdValid2019', label: t('nav.stdValid2019'), key: '/platformAssistant?type=1&key=2019', mode: ["surveyDesign_teamworks_tandard_2019"] },
              { labelKey: 'nav.stdValid2020', label: t('nav.stdValid2020'), key: '/platformAssistant?type=1&key=2020', mode: ["surveyDesign_teamworks_tandard_2020"] },
              { labelKey: 'nav.stdValid2021', label: t('nav.stdValid2021'), key: '/platformAssistant?type=2&key=2021', mode: ["surveyDesign_teamworks_tandard_2021"] },
              { labelKey: 'nav.stdValid2022', label: t('nav.stdValid2022'), key: '/platformAssistant?type=2&key=2022', mode: ["surveyDesign_teamworks_tandard_2022"] },
              { labelKey: 'nav.stdValid2023', label: t('nav.stdValid2023'), key: '/platformAssistant?type=2&key=2023', mode: ["surveyDesign_teamworks_tandard_2023"] },
              { labelKey: 'nav.stdValid2024', label: t('nav.stdValid2024'), key: '/platformAssistant?type=2&key=2024', mode: ["surveyDesign_teamworks_tandard_2024"] },
              { labelKey: 'nav.intlStd2018', label: t('nav.intlStd2018'), key: '/platformAssistant?type=3&key=2018', mode: ["surveyDesign_teamworks_internation_2018"] },
              { labelKey: 'nav.intlStd2019', label: t('nav.intlStd2019'), key: '/platformAssistant?type=3&key=2019', mode: ["surveyDesign_teamworks_internation_2019"] },
              { labelKey: 'nav.intlStd2020', label: t('nav.intlStd2020'), key: '/platformAssistant?type=3&key=2020', mode: ["surveyDesign_teamworks_internation_2020"] },
              { labelKey: 'nav.intlStd2021', label: t('nav.intlStd2021'), key: '/platformAssistant?type=4&key=2021', mode: ["surveyDesign_teamworks_internation_2021"] },
              { labelKey: 'nav.intlStd2022', label: t('nav.intlStd2022'), key: '/platformAssistant?type=4&key=2022', mode: ["surveyDesign_teamworks_internation_2022"] },
              { labelKey: 'nav.intlStd2023', label: t('nav.intlStd2023'), key: '/platformAssistant?type=4&key=2023', mode: ["surveyDesign_teamworks_internation_2023"] },
              { labelKey: 'nav.intlStd2024', label: t('nav.intlStd2024'), key: '/platformAssistant?type=4&key=2024', mode: ["surveyDesign_teamworks_internation_2024"] }
            ]
          },
        ]
      }
    },
    setData() {
      let { standardSearchList = {}, platformAssistantList = {} } = this;
      const isEnglish = this.$store.state.language === 'english';
      // 英文版隐藏：用稳定 labelKey，不依赖中文文案
      const hideInEnglish = new Set(['nav.platformAssistant', 'nav.call', 'nav.ceppea']);
      let list = [
        { labelKey: 'nav.home', label: t('nav.home'), key: "/home" },
        standardSearchList,
        { labelKey: 'nav.digitization', label: t('nav.digitization'), key: "/digitization", rolesKey: "digitization", mode: ["digitization_list"] },
        {
          labelKey: 'nav.benchmarking',
          label: t('nav.benchmarking'),
          key: `/benchmarking?type=0`,
          rolesKey: "benchmarking",
          mode: ["benchmarking_details"],
          value: `${this.$FN.iframeUrl}/npg/kres/output`,
          children: [
            { labelKey: 'nav.benchmarkSurvey', label: t('nav.benchmarkSurvey'), key: "/benchmarking?type=0", mode: ["benchmarking_details"] },
            { labelKey: 'nav.benchmarkInstall', label: t('nav.benchmarkInstall'), key: "/benchmarking?type=1", mode: ["benchmarking_reconnaissance_list"] },
          ]
        },
        { labelKey: 'nav.standardTranslation', label: t('nav.standardTranslation'), key: "/standardTranslation", rolesKey: "standardTranslation", mode: ["standardTranslation_list"] },
        // 英文版该词条过长，从第二行起排（enRowBreak 触发 flex 强制换行）
        { labelKey: 'nav.technicalRegulations', label: t('nav.technicalRegulations'), key: "/technicalRegulations", rolesKey: "technicalRegulations", mode: ["technicalRegulations_list"], enRowBreak: isEnglish },
        { labelKey: 'nav.languageService', label: t('nav.languageService'), key: "/languageService", rolesKey: "languageService", mode: ["languageService_order"] },
        { labelKey: 'nav.call', label: t('nav.call'), key: "/call", rolesKey: "call", mode: ["call_list"] },
        { labelKey: 'nav.informationNavigation', label: t('nav.informationNavigation'), key: "/informationNavigation", rolesKey: "informationNavigation", mode: ["informationNavigation_list"] },
        { labelKey: 'nav.standardList', label: t('nav.standardList'), key: "/standardList/item", rolesKey: "standardList", mode: ["standardList_list_item"] },
        platformAssistantList,
        { labelKey: 'nav.ceppea', label: t('nav.ceppea'), key: `/ceppeaStandard`, rolesKey: "ceppea" }
      ];
      if (isEnglish) {
        list = list.filter(item => item && item.labelKey && !hideInEnglish.has(item.labelKey));
      }
      this.data = this.$FN.filterLimitsVisible({ data: list });
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
<style lang="less">
body {
  .antd_menu_navigation {
    position: relative;
    top: -3px;
    .ant-dropdown-menu-item {
      text-align: center;
      .active {
        font-weight: bold;
        color: @vice-color;
      }
    }
    // 标准检索 - 中外标准对标展示
    .ant-menu {
      padding: 10px 0;
      .ant-menu-item {
        height: 35px;
        line-height: 35px;
        margin: 0 !important;
        // background: pink;
      }
      .ant-menu-item-active {
        font-weight: bold;
      }
      .ant-menu-item-selected {
        color: @vice-color;
        font-weight: bold;
      }
    }
  }
  .ant-modal-root {
    .antd_modal {
      img {
        width: 100%;
      }
      .antd-model-tips {
        .pub_font_size();
        margin-top: 10px;
      }
    }
  }

  // 平台助手-菜单-子菜单
  .ant-menu-submenu-popup {
    .ant-menu {
      padding: 5px 0;
      .antd_menu_item_default {
        height: 35px;
        line-height: 35px;
      }
      .ant-menu-item-active {
        font-weight: bold;
      }
      .ant-menu-item-selected {
        color: @vice-color;
        font-weight: bold;
      }
    }
  }
}
</style>
